export const getTagsList = (t: (key: string) => string) => [
  { label: t("company.tags.untagged"), value: "UNTAGGED" },
  { label: t("company.tags.toQualify"), value: "TO_QUALIFY" },
  { label: t("company.tags.prospect"), value: "PROSPECT" },
  { label: t("company.tags.hotProspect"), value: "HOT_PROSPECT" },
  { label: t("company.tags.client"), value: "CLIENT" },
  { label: t("company.tags.outOfTarget"), value: "OUT_OF_TARGET" },
  { label: t("company.tags.partner"), value: "PARTNER" },
  { label: t("company.tags.competitor"), value: "COMPETITOR" },
];
